// extracted by mini-css-extract-plugin
module.exports = {"adminWrapper":"AdminWrapper_adminWrapper__3CDyH"};